<template>
  <div class="card">
    <div class="card__title">
      <h5>Detalle de la retención</h5>
    </div>
    <div class="card__content">
      <div class="table-responsive">
        <table>
          <thead>
            <tr>
              <th></th>
              <th>
                <button
                  :disabled="disabled"
                  @click="agregarTarifa"
                  class="btn-success"
                >
                  <i class="fa fa-plus"></i>
                </button>
              </th>
              <th>Impuesto</th>
              <th>Base imponible</th>
              <th>Porcentaje</th>
              <th>Valor</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(tarifa, index) in modelValue" :key="index">
              <th scope="row">
                {{ index + 1 }}
              </th>
              <td>
                <button
                  :disabled="disabled"
                  @click="editarTarifa(index)"
                  class="btn-info btn--text"
                  type="button"
                >
                  <i class="fa fa-edit"></i>
                </button>
              </td>
              <td
                :tooltip="
                  tarifa.selectedTarifa !== null &&
                  tarifa.selectedTarifa.nombre !== ''
                    ? tarifa.selectedTarifa.nombre
                    : 'Seleccione...'
                "
              >
                <div class="form-field">
                  <input-field
                    :id="'tarifas' + index"
                    placeholder="Tarifa"
                    readonly
                    :value="
                      tarifa.selectedTarifa != null
                        ? tarifa.selectedTarifa.nombre
                        : ''
                    "
                  >
                    <span
                      v-if="
                        errores.hasOwnProperty(
                          'detalles.' + index + '.selectedTarifa.id_tarifa'
                        )
                      "
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{
                        errores[
                          "items." + index + ".selectedTarifa.id_tarifa"
                        ][0]
                      }}</strong>
                    </span>
                    <span
                      v-else-if="
                        errores.hasOwnProperty(
                          'detalles.' + index + '.selectedTarifa.id_impuesto'
                        )
                      "
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{
                        errores[
                          "items." + index + ".selectedTarifa.id_impuesto"
                        ][0]
                      }}</strong>
                    </span>
                  </input-field>
                </div>
              </td>
              <td>
                <input-field
                  readonly
                  vMoney
                  :format="money"
                  v-model="tarifa.base_imponible"
                  :id="'baseImponible' + index"
                  placeholder="$ #,###.##"
                >
                  <span
                    v-if="
                      errores.hasOwnProperty(
                        'detalles.' + index + '.base_imponible'
                      )
                    "
                    class="helper-text text-danger"
                    slot="helper"
                  >
                    <strong>{{
                      errores["items." + index + ".base_imponible"][0]
                    }}</strong>
                  </span>
                </input-field>
              </td>
              <td>
                <input-field
                  readonly
                  vMoney
                  :format="decimal"
                  v-model="tarifa.porcentaje"
                  :id="'porcentaje' + index"
                  placeholder="Seleccione..."
                >
                  <span
                    v-if="
                      errores.hasOwnProperty(
                        'detalles.' + index + '.porcentaje'
                      )
                    "
                    class="helper-text text-danger"
                    slot="helper"
                  >
                    <strong>{{
                      errores["items." + index + ".porcentaje"][0]
                    }}</strong>
                  </span>
                </input-field>
              </td>
              <td>
                <input-field
                  readonly
                  vMoney
                  :format="money"
                  v-model="tarifa.valor"
                  :id="'valor' + index"
                >
                  <span
                    v-if="
                      errores.hasOwnProperty('detalles.' + index + '.valor')
                    "
                    class="helper-text text-danger"
                    slot="helper"
                  >
                    <strong>{{
                      errores["items." + index + ".valor"][0]
                    }}</strong>
                  </span>
                </input-field>
              </td>
              <td>
                <button
                  :disabled="disabled"
                  @click="eliminarTarifa(index)"
                  class="btn-danger btn--text"
                  type="button"
                >
                  <i class="fa fa-trash-o"></i>
                </button>
              </td>
            </tr>
            <tr v-show="modelValue.length === 0">
              <td colspan="6">
                <strong>No se ha agregado detalles.</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <modal
      :clickToClose="false"
      name="itemRetencion"
      width="60%"
      height="auto"
      scrollable
    >
      <item-retencion
        :venta="venta"
        :codigoIva="codigoIva"
        :codigoIsd="codigoIsd"
        :codigoRenta="codigoRenta"
        :baseImponibleIsd="baseImponibleIsd"
        :baseImponibleIva="baseImponibleIva"
        :baseImponibleRenta="baseImponibleRenta"
        @cancelar="cancelarTarifa"
        @input="aceptarTarifa"
        :impuestos="impuestos"
        v-model="selectedItem"
        :fechaEmision="fechaEmision"
      ></item-retencion>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    impuestos: {
      type: Array,
      required: true,
    },
    errores: {
      type: Object,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
    baseImponibleIsd: {
      required: true,
    },
    baseImponibleIva: {
      required: true,
    },
    baseImponibleRenta: {
      required: true,
    },
    codigoIva: {
      required: true,
      type: String,
    },
    codigoRenta: {
      required: true,
      type: String,
    },
    codigoIsd: {
      required: true,
      type: String,
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
    venta: {
      required: false,
      type: Boolean,
      default: false,
    },
    fechaEmision: {
      required: false,
      default: function () {
        return null;
      },
    },
  },
  data: function () {
    return {
      modelValue: this.value,
      money: money,
      decimal: decimal,
      selectedItem: {
        selectedTarifa: {
          nombre: "",
        },
        base_imponible: 0,
        porcentaje: 0,
        valor: 0,
        selectedImpuesto: {
          nombre: "",
        },
      },
      nuevaTarifa: false,
      selectedIndex: -1,
    };
  },
  methods: {
    eliminarTarifa: function (index) {
      swal({
        title: "¿Deseas eliminar este detalle?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) this.modelValue.splice(index, 1);
      });
    },
    editarTarifa: function (index) {
      this.selectedItem = JSON.parse(JSON.stringify(this.modelValue[index]));
      this.selectedIndex = index;
      this.$modal.show("itemRetencion");
    },
    agregarTarifa: function () {
      let fechaIncorrecta = false;
      if (this.fechaEmision == null || this.fechaEmision == "") {
        swal(
          "Aviso",
          "Debe ingresar la fecha de emisión de la retención",
          "warning"
        );
        return;
      }
      this.nuevaTarifa = true;
      this.$modal.show("itemRetencion");
      let item = {
        selectedTarifa: {
          descripcion: "",
        },
        base_imponible: 0,
        porcentaje: 0,
        valor: 0,
      };
      this.selectedIndex = this.modelValue.push(item) - 1;
      this.selectedItem = JSON.parse(JSON.stringify(item));
    },
    aceptarTarifa: function (tarifa) {
      this.modelValue.splice(this.selectedIndex, 1, tarifa);
      this.nuevaTarifa = false;
      this.$modal.hide("itemRetencion");
    },
    cancelarTarifa: function () {
      if (this.nuevaTarifa) {
        this.modelValue.splice(this.selectedIndex, 1);
        this.nuevaTarifa = false;
      }
      this.$modal.hide("itemRetencion");
    },
  },
  watch: {
    value: function (value) {
      this.modelValue = value;
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/TablaDetalleRetencion.vue